import axios from 'axios';

const updateParameterData = async target => {
  const row = $(target).parents('tr');
  const parameterTypeId = row.find('.js-parameter-type-select').val();
  const unitSelect = row.find('.js-unit-select');
  const parameterValueField = row.find('.js-parameter-value');

  try {
    const res = await axios.get(`/parameter_types/${parameterTypeId}.json`);
    const { data } = res;
    parameterValueField.val(data.default_value);
    unitSelect.val(data.measurement_unit_id);
    unitSelect.trigger('change');
  } catch (error) {
    console.log(error.response.data);
  }
};

const updateRowOnParameterTypeChange = () => {
  $('.parameter_type_rows .js-parameter-type-select').on(
    'change',
    function (e) {
      const target = $(e.currentTarget);
      updateParameterData(target);
    }
  );
};

document.addEventListener('turbolinks:load', function () {
  $('.parameter_type_rows').on('cocoon:after-insert', function () {
    $('select').select2({
      width: '100%',
    });

    updateRowOnParameterTypeChange();
  });

  updateRowOnParameterTypeChange();
});
